import { tryAxios } from '@/api/common/auth'
import { urlPrefix } from '@/configs/api'

const apiUrl = `${urlPrefix}/healthRule`
//#region 基本信息
const Post = `${apiUrl}`
const Get = `${apiUrl}`
//#endregion

export class HealthRuleData {
    [key: string]: any
    ColorList: HRColorData[]
    ColorScoreList: HRColorScoreData[]
    RedCodeRuleList: HRRedCodeRuleData[]
    RuleList: HRRuleData[]
    constructor() {
        this.ColorList = []
        this.ColorScoreList = []
        this.RedCodeRuleList = []
        this.RuleList = []
    }
}

export class HRColorData {
    [key: string]: any
    Id: number
    ColorType: number
    ColorValue: string

    constructor() {
        this.Id = 0
        this.ColorType = 0
        this.ColorValue = ''
    }
}
export class HRColorScoreData {
    [key: string]: any
    Id: number
    ColorType: number
    MaxScore: number
    MinScore: number

    constructor() {
        this.Id = 0
        this.ColorType = 0
        this.MaxScore = 0
        this.MinScore = 0
    }
}
export class HRRedCodeRuleData {
    [key: string]: any
    Id: number
    AreaType: number
    RedRate: number
    YellowRate: number

    constructor() {
        this.Id = 0
        this.AreaType = 0
        this.RedRate = 0
        this.YellowRate = 0
    }
}
export class HRRuleData {
    [key: string]: any
    Id: number
    RuleCode: string
    RuleName: string
    RuleContent: string
    RuleParam: string
    JudgeFlag: string
    ResultParam: string
    AddFlag: boolean
    RuleSorce: number
    Comments: string
    /** 1关闭 2开启 */
    Status: number

    constructor() {
        this.Id = 0
        this.RuleCode = ''
        this.RuleName = ''
        this.RuleContent = ''
        this.RuleParam = ''
        this.JudgeFlag = ''
        this.ResultParam = ''
        this.AddFlag = false
        this.RuleSorce = 0
        this.Comments = ''
        this.Status = 0
    }
}

export const getInfo = () => {
    return tryAxios({
        method: 'get',
        url: Get
    })
}
export const postData = (form: HealthRuleData) => {
    return tryAxios({
        method: 'post',
        url: Post,
        data: form
    })
}
